// extracted by mini-css-extract-plugin
export default {"logos":"Accreditations_logos__20eoX","logo":"Accreditations_logo__hyhTb","image":"Accreditations_image__tkQq4","middle":"Accreditations_middle__IZ1z6"};